// 检查是否是真正的 .txt 文件（文本文件）
export const isTextFile = (fileBuffer) => {
    // 文本文件没有固定的魔数，但可以检查是否都是可打印字符
    const buffer = fileBuffer.slice(0, 1024); // 检查前1KB
    for (let i = 0; i < buffer.length; i++) {
        if (buffer[i] < 32 && buffer[i] !== 9 && buffer[i] !== 10 && buffer[i] !== 13) {
            // 发现非文本字符（制表符、换行符、回车符除外）
            return false;
        }
    }
    return true;
}

// 检查是否是真正的 .doc 文件
export const isDocFile = (fileBuffer) => {
    // .doc 文件签名：D0 CF 11 E0 A1 B1 1A E1
    const signature = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
    const header = new Uint8Array(fileBuffer.slice(0, 8));
    return header.every((byte, index) => byte === signature[index]);
}

// 检查是否是真正的 .docx 文件
export const isDocxFile = (fileBuffer) => {
    // .docx 实际上是ZIP压缩包，签名：50 4B 03 04
    const signature = [0x50, 0x4B, 0x03, 0x04];
    const header = new Uint8Array(fileBuffer.slice(0, 4));
    return header.every((byte, index) => byte === signature[index]);
}

// 通过文件内容检测MIME类型
// 通过文件内容检测MIME类型
export const getMimeTypeFromBuffer = (fileBuffer) => {
    const signatures = {
        // 先检查有明确魔数的文件类型
        'application/msword': function (buf) {
            return isDocFile(buf);
        },
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': function (buf) {
            return isDocxFile(buf);
        },
        // 最后检查文本文件（作为兜底）
        'text/plain': function (buf) {
            return isTextFile(buf);
        }
    };

    for (const [mimeType, check] of Object.entries(signatures)) {
        if (check(fileBuffer)) {
            return mimeType;
        }
    }
    return 'application/octet-stream'; // 未知类型
}
export const formatFileSizePrecise = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 B';

    const k = 1024;
    const sizes = ['B', 'K', 'M', 'G', 'T'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
}
// fileValidator.js
export default async function validateUploadedFile(file, expectedTypes = [], supportTypes = [], size = 0, doct = '') {
    // const buffer = await file.arrayBuffer();
    // const fileBuffer = new Uint8Array(buffer);

    // // 1. 获取文件扩展名（仅供参考）
    const extension = file.name.split('.').pop().toLowerCase();

    // // 2. 获取真实的MIME类型
    // const realMimeType = getMimeTypeFromBuffer(fileBuffer);

    // 3. 验证扩展名与真实类型是否匹配
    // if (!expectedTypes.includes(realMimeType)) {
    //     throw new Error(`文件类型不匹配：声明为 .${extension}，实际为 ${realMimeType}`);
    // }
    if (!expectedTypes.includes(file.type)) {
        throw new Error(`文件类型不匹配:只支持${supportTypes.join(' , ')}`);
    }
    // 4.验证文件大小
    if (file.size == 0) {
        throw new Error(`请上传有内容的文件`);
    }
    if (file.size > size) {
        throw new Error(`文件大小超过${doct}`);
    }

    return { extension, mimeType: file.type, file, isValid: true };
}
